import { render } from "./Index_enterprise_en.vue?vue&type=template&id=196a801b&scoped=true"
import script from "./Index_enterprise_en.vue?vue&type=script&lang=js"
export * from "./Index_enterprise_en.vue?vue&type=script&lang=js"

import "./Index_enterprise_en.vue?vue&type=style&index=0&id=196a801b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-196a801b"

export default script